import {Injectable} from "@angular/core";
import {NativeDateAdapter} from "@angular/material/core";

const GERMAN_DATE_PATTERN = /^(\d{1,2})\.(\d{1,2})\.(\d{2}|\d{4})$/;

/**
 * Der NativeDateAdapter kann manuell eingegebene Daten im Format TT.MM.JJJJ nicht lesen.
 * Dieser Adapter ergänzt das deutsche Format und nutzt ansonsten das Standardverhalten.
 */
@Injectable()
export class GermanDateAdapter extends NativeDateAdapter {
  override parse(value: unknown, parseFormat?: unknown): Date | null {
    if (typeof value === 'string') {
      const match = value.trim().match(GERMAN_DATE_PATTERN);

      if (match) {
        const day = Number(match[1]);
        const month = Number(match[2]) - 1;
        const year = match[3].length === 2 ? 2000 + Number(match[3]) : Number(match[3]);
        const date = new Date(year, month, day);

        // Ungültige Angaben wie 31.02. würden sonst in den Folgemonat verschoben
        if (date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day) {
          return this.invalid();
        }

        return date;
      }
    }

    return super.parse(value, parseFormat);
  }
}

// Wandelt ein Datum der API (YYYY-MM-DD) in ein lokales Datum um, ohne Verschiebung durch die Zeitzone
export function parseIsoDate(value: string | null | undefined): Date | null {
  const match = value?.match(/^(\d{4})-(\d{2})-(\d{2})/);

  return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])) : null;
}

// Wandelt ein lokales Datum in das Format der API (YYYY-MM-DD) um
export function formatIsoDate(date: Date | null | undefined): string | null {
  if (!date || isNaN(date.getTime())) {
    return null;
  }

  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
  ].join('-');
}
